<template>
<div>
  <div style="width: calc(100vw - 450px);">
    <el-descriptions :column="2" border size="mini" :label-style="{width: '100px'}">
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
          <el-option
            v-for="item in meter_type_list"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="当前房产">
        <el-input size="mini" placeholder="请选择房产" v-model="house" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表性质">
        <el-checkbox-group v-model="where.meter_nature_ids">
          <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-checkbox-group v-model="where.energy_ids">
          <el-checkbox v-for="(item,index) in energy_list" :disabled="!isEnergyAble(item.val)" :label="item.val" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="下载操作">
        <el-button size="mini" type="primary" @click="dowExcel()" style="margin-right: 5px;">下载模板</el-button>
      </el-descriptions-item>
      <el-descriptions-item label="导入操作">
        <el-button size="mini" type="primary" @click="uploadExcel()" style="margin-right: 5px;">上传模板</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length&&excel_list_not_input_num" type="primary" @click="importExcel">导入</el-button>
        <el-button size="mini" v-if="excel_list&&excel_list.length" type="warning" @click="cleanImportExcel">取消</el-button>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <div class="search-wrap" style="flex-direction: column">
      <div style="display: flex;flex-direction: row;margin-top: 20px;">
        <div>
          总条数： <span style="color: #038dce">{{excel_list_num}}</span> 条
        </div>
        <div style="margin-left: 50px">
          未填条数： <span style="color: #ff3d00">{{excel_list_not_input_num}}</span> 条
        </div>
      </div>
    </div>
    <div class="table-wrap">
      <el-table v-loading="loading" :data="pageData.list" :height="__TABLE_HEIGHT__" @selection-change="handleSelectionChange">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="number" label="仪表编号" align="center" width="100"></el-table-column>
        <el-table-column prop="name" label="仪表名称" align="center" width="180"></el-table-column>
        <el-table-column prop="house_name" label="所在房产" align="center" width="100"></el-table-column>
        <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="120"></el-table-column>
        <el-table-column prop="position" label="位置" align="center" width="100"></el-table-column>
        <el-table-column prop="last_last_read_time" label="上上期抄表日期" align="center" width="180"></el-table-column>
        <el-table-column prop="last_last_read_number" label="上上次抄表读数" align="center" width="180"></el-table-column>
        <el-table-column prop="last_read_time" label="上期抄表日期" align="center" width="180"></el-table-column>
        <el-table-column prop="last_read_number" label="上次抄表读数" align="center" width="180"></el-table-column>
        <el-table-column prop="read_number" label="抄表读数" align="center" width="180"></el-table-column>
        <el-table-column prop="read_time" label="抄表日期" align="center" width="180"></el-table-column><el-table-column prop="last_last_read_time" label="上上期抄表日期" align="center" width="180"></el-table-column>
        <el-table-column prop="admin_name" label="抄表人" align="center" width="180"></el-table-column>
        <el-table-column prop="remarks" label="备注" align="center" width="180"></el-table-column>
        <el-table-column prop="dosage_number" label="本次用量" align="center" width="180"></el-table-column>
        <el-table-column prop="allowance_number" label="本次余量" align="center" width="180"></el-table-column>
        <el-table-column prop="dosage_money" label="本次金额" align="center" width="180"></el-table-column>
        <el-table-column prop="customer_name" label="业主" align="center" width="180"></el-table-column>
        <el-table-column prop="rent_name" label="租户" align="center" width="180"></el-table-column>
        <el-table-column prop="magnification" label="仪表倍率" align="center" width="180"></el-table-column>
        <el-table-column prop="id" label="系统编号" align="center" width="180"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
        <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ErpTreeStatus from "../../../Common/erp-tree-status";
import UploadFileSysc from "../../../Meter/components/UploadFileSysc";
import Http from "../../common/Http";
import CommonMixin from "../../common/CommonMixin";
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterNoteExcel",
  components: {ErpTreeStatus, UploadFileSysc},
  mixins:[CommonMixin],
  inject:['mainObj','componentId','setComponentId'],
  data () {
    return {
      host_url:"",
      loading: false,
      activeName:"meter_export",
      where:{
        project_id:"",
        house_name:"",
        meter_nature_ids:[1,2,3,4],
        energy_ids:this.getDefaultEnergyIds(),
        meter_virtually:[1]
      },
      house:'',
      excel_list:[],
      dialogVisible:false,
      form:{
        name:"",
        xsc_code:"",
        status:"",
        invoicing_limit:"",
        refund_audit:"",
        sort:"",
        expense_category:"",
        bill_type:"",
        files:"",
        financial_code:"",
        financial_code_name:"",
        remarks:"",
      },
      house_charge_list:[],
      house_charge_item_list:[],
      excel_file:"",
      meter_type_list: [],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      pageData:{
        list:[],
        total: 0,
        pageSize: 15,
        page: 1
      },
    }
  },
  mounted() {
    this.host_url=__HTTP__.defaults.baseURL;
    this.getMeterTypeList()
    this.where.project_id = this.mainObj.project_id;
    this.where.house_name=this.mainObj.house_name;
    this.house = this.mainObj.house_name;
  },
  activated() {
    // this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "where.project_id":function (n) {
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "mainObj.house_name":function (n) {
      const that=this;
      this.where.project_id = that.mainObj.project_id;
      this.where.house_name=n;
      this.house = n;
    }

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    excel_list_num(){
      return this.excel_list.length
    },
    excel_list_not_input_num(){
      return this.excel_list.filter(ret=>{
        return (ret.read_time&&ret.admin_name&&ret.read_number)?true:false;
      }).length
    },
  },
  methods: {
    showExcel(excel_file) {
      const that = this;
      that.loading=true;
      if(!excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      MeterHttp.post("MeterNote/meterImportExcelShow",{
        project_id:that.mainObj.project_id,
        file:excel_file,
      },res=>{
        that.loading=false;
        if(res.code) {
          that.excel_list=res.data
          that.pageData.total=that.excel_list.length
          that.excel_file=excel_file;
          that.pageChange(1)
        }else {
          that.$message.error(res.msg||"表格解析异常");
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      let list=reObject(that.excel_list)
      that.pageData.list=list.splice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.pageSize);
    },
    importExcel() {
      const that = this;
      if(!that.excel_file){
        this.$message.error('请提交Excel表单');
        return false;
      }
      if(!that.excel_list||!that.excel_list.length){
        this.$message.error('Excel表单无数据');
        return false;
      }

      that.$confirm('您确定导入Excel表单数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        MeterHttp.post("MeterNote/meterImportExcel?user_type="+(that.$route.query.type||0),{
          project_id:that.mainObj.project_id,
          file:that.excel_file,
        },res=>{
            if(res.code) {
              that.$message.success('Excel表单导入成功');
              that.excel_list=[];
              that.excel_file=""
            }else {
              that.$message.error(res.msg||'Excel表单导入失败');
            }
            that.loading=false;
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消导入'
        });
      });

    },
    cleanImportExcel(){
      this.excel_file=""
      this.excel_list=[]
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.where.project_id = data.tree[0].pindex_id;
      this.where.house_name=tree_str;
      this.house = tree_str;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.where.project_id&&(where.pindex_id=this.where.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      MeterHttp.get("HouseCharge/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    dowExcel(){
      if(this.house == ''){
        this.$message.error('点击左边的树选择项目');
        return false;
      }
      const that = this;
      let where=reObject(that.where);
      ERP.showLoading()
      MeterHttp.get("MeterNote/MeterExportExcel",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        user_type:(that.$route.query.type||0),
      },ret=>{
        ERP.hideLoading()
        if(ret.code){
          if(ret.data.indexOf("http")===-1){
            window.open(__HTTP__.defaults.baseURL +ret.data)
          }else {
            window.open(ret.data)
          }
        }
      })

    },
    uploadExcel(){
      const that=this;
      MeterHttp.uploadFile(file=>{
        that.showExcel(file)
      })
    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterNoteImport.vue